import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import locale from "@amcharts/amcharts4/lang/pt_BR.js";
import { customizeChartGrip } from "../../utils/customizeChartGrip";


export function montarGraficoDia({ id, lista, diferencaEmDias, isMobile, setGrafico, registro }) {
    am4core.useTheme(am4themes_animated);

    const modoSimulado = lista[0] && !isNaN(parseFloat(lista[0].q_simulado)); //se tem q_simulado a lista está no modo simulada

    let chart = am4core.create(id, am4charts.XYChart);

    // Configura título e subtítulo
    const subtitle = chart.titles.create();
    subtitle.text = registro.nome_unidade_consumidora;
    subtitle.fontWeight = "bold";
    subtitle.fontSize = window.innerWidth < 1150 ? "0.7rem" : "1rem";
    subtitle.fill = am4core.color("#000");
    subtitle.marginBottom = 10;

    const title = chart.titles.create();
    title.text = "Gráfico de Demanda Direta (Consumo)";
    title.fontWeight = "bold";
    title.fontSize = window.innerWidth < 1150 ? "0.8rem" : "1.2rem";
    title.fill = am4core.color("#000");
    title.marginBottom = 20;

    chart.exporting.menu = new am4core.ExportMenu();
    chart.exporting.filePrefix = "Gráfico";
    chart.exporting.menu.align = "right";
    chart.exporting.menu.verticalAlign = "top";
    chart.exporting.menu.items = [
        {
            label: "...",
            menu: [
                {
                    type: "png",
                    label: "PNG",
                },
            ],
        },
    ];
    chart.language.locale = locale;
    chart.language.locale["_decimalSeparator"] = ",";
    chart.language.locale["_thousandSeparator"] = ".";
    chart.numberFormatter.numberFormat = "###,###,###,###.00";

    // Configura eixo X
    const dateAxis = chart.xAxes.push(new am4charts.DateAxis());
    dateAxis.renderer.grid.template.location = 0;
    dateAxis.startLocation = 0.5;
    dateAxis.endLocation = 0.5;
    // dateAxis.dateFormats.setKey("minute", "HH:mm");

    dateAxis.baseInterval = {
        timeUnit: "minute",
        count: 15,
    };

    // Lógica para ajustar os rótulos com base no intervalo de dados
    if (lista.length) {
        const firstDate = new Date(lista[0].data_hora);
        const lastDate = new Date(lista[lista.length - 1].data_hora);
        const isSingleDay = firstDate.toDateString() === lastDate.toDateString();

        if (isSingleDay) {
            // Exibe apenas horas se os dados forem de um único dia
            dateAxis.dateFormats.setKey("hour", "HH:mm");
            dateAxis.dateFormats.setKey("minute", "HH:mm");
        } else {
            // Exibe dias para múltiplos dias
            dateAxis.dateFormats.setKey("day", "dd/MM\nEEE");
        }
    }

    // Centraliza os rótulos no eixo
    dateAxis.renderer.labels.template.textAlign = "middle";
    dateAxis.renderer.labels.template.fill = am4core.color("#000");
    dateAxis.renderer.maxLabelPosition = 0.95;
    dateAxis.renderer.minGridDistance = 40;
    dateAxis.renderer.minLabelPosition = 0.05;

    // Configura eixo Y compartilhado para "P (kW)" e "Q (kVAr)"
    const valueAxis = chart.yAxes.push(new am4charts.ValueAxis());

    valueAxis.renderer.labels.template.fill = am4core.color("#000");

    // adiciona 20% de espaço acima do valor máximo
    valueAxis.extraMax = 0.2;

    if (!isMobile) {
        valueAxis.renderer.marginLeft = 30;
        valueAxis.renderer.marginRight = 20;
        valueAxis.title.text = "P (kW) / Q (kVAr)";
    }
    // valueAxis.renderer.labels.template.fontSize = 12;
    // valueAxis.min = 0;

    if (isMobile) {
        chart.paddingLeft = 5;
        // Eixo X
        dateAxis.renderer.labels.template.fontSize = 10;

        // Eixo Y
        valueAxis.renderer.labels.template.fontSize = 10;
    }

    // Série para "P (kW)"
    const seriesP = chart.series.push(new am4charts.LineSeries());
    seriesP.dataFields.valueY = "p"; // Campo para "P (kW)"
    seriesP.dataFields.dateX = "data_hora";
    seriesP.name = "P (kW)";
    seriesP.tooltipText = `P (kW) às {dateX.formatDate("dd/MM/yyyy HH:mm")}h: [bold]{valueY.formatNumber("###,###,###,###.00")} kW[/]`;
    seriesP.strokeWidth = 2;
    seriesP.tensionX = 1;
    seriesP.stroke = am4core.color("#017acd");
    seriesP.fill = am4core.color("#017acd");
    seriesP.fillOpacity = 0.2;

    // Série para "Q (kVAr)"
    const seriesQ = chart.series.push(new am4charts.LineSeries());
    seriesQ.dataFields.valueY = "q"; // Campo para "Q (kVAr)"
    seriesQ.dataFields.dateX = "data_hora";
    seriesQ.name = "Q (kVAr)";
    seriesQ.tooltipText = `Q (kVAr) às {dateX.formatDate("dd/MM/yyyy HH:mm")}h: [bold]{valueY.formatNumber("###,###,###,###.00")} kVAr[/]`;
    seriesQ.strokeWidth = 2;
    seriesQ.tensionX = 1;
    seriesQ.stroke = am4core.color("#1bd07c");
    seriesQ.fill = am4core.color("#1bd07c");
    seriesQ.fillOpacity = 0.2;
    // Certifique-se de que seus dados incluam o campo 'demanda_contratada_horario'
    // Exemplo de estrutura de dados:
    // chart.data = [
    //   { data_hora: new Date(2023, 0, 1), demanda_contratada_quantidade: 100, demanda_contratada_horario: "FORA PONTA" },
    //   { data_hora: new Date(2023, 0, 2), demanda_contratada_quantidade: 120, demanda_contratada_horario: "PONTA" },
    //   { data_hora: new Date(2023, 0, 3), demanda_contratada_quantidade: 110, demanda_contratada_horario: "FORA PONTA" },
    // ];

    const seriesAtivas = [seriesP, seriesQ];

    if (diferencaEmDias <= 62) {
        // Série para "Demanda Contratada (kW)"
        const seriesDem = chart.series.push(new am4charts.LineSeries());
        seriesDem.dataFields.valueY = "demanda_contratada_quantidade";
        seriesDem.dataFields.dateX = "data_hora";
        seriesDem.name = "Demanda Contratada (kW)"; // Nome genérico, o tooltip detalhará
        seriesDem.stroke = am4core.color("#cd0137"); // Cor da linha base
        seriesDem.strokeWidth = 4;
        seriesDem.tensionX = 1;

        // Configurações de Tooltip padrão
        seriesDem.tooltip.getFillFromObject = false;
        seriesDem.tooltip.background.fill = seriesDem.stroke;
        seriesDem.tooltip.label.fill = am4core.color("#fff");

        // ADAPTADORES PARA CONTROLE DINÂMICO

        // 1. Adaptador para tooltipText
        seriesDem.adapter.add("tooltipText", function (text, target) {
            // target.tooltipDataItem.dataContext contém os dados do ponto atual
            const dataContext = target.tooltipDataItem.dataContext;
            if (dataContext && dataContext.demanda_contratada_horario) {
                const horario = dataContext.demanda_contratada_horario;
                const tipoDemanda = horario === "PONTA" ? "Ponta" : "Fora Ponta";
                return `Demanda ${tipoDemanda} Contratada às {dateX.formatDate("dd/MM/yyyy HH:mm")}h [bold]{valueY.formatNumber("###,###,###,###.00")} kW[/]`;
            }
            return text; // Retorna o texto padrão se a condição não for atendida
        });

        // 1. Defina a cor e uma opacidade BASE na série (Essencial para ativar o motor de renderização de fill)
        seriesDem.fill = am4core.color("#cd0137");
        seriesDem.fillOpacity = 0;

        function adicionarRange(inicio, fim, cor, texto, opacidade = 0.2) {
            let range = dateAxis.axisRanges.create();
            range.date = inicio;
            range.endDate = fim;
            range.axisFill.fill = am4core.color(cor);
            range.axisFill.fillOpacity = opacidade;
            range.grid.strokeOpacity = 0;

            //  TEXTO
            if (isMobile) {
                if (diferencaEmDias <= 2) {
                    range.label.text = texto;
                } else {
                    range.label.text = String(texto)[0];
                }
            } else {
                if (diferencaEmDias <= 5) {
                    range.label.text = texto;
                } else if (diferencaEmDias <= 30) {
                    range.label.text = String(texto)[0];
                } else {
                    range.label.text = "";
                }
            }
            range.label.fill = am4core.color(cor);
            range.label.fontWeight = "600";
            range.label.fontSize = 12;

            // centro horizontal
            range.label.location = 0.5;
            range.label.horizontalCenter = "middle";

            // ancora a base do texto
            range.label.verticalCenter = "bottom";

            // sobe
            range.label.dy = -165;
        }

        let inicioPonta = null;
        let inicioReservado = null;

        lista.forEach((item, index) => {
            const dataAtual = new Date(item.data_hora);

            if (item.demanda_contratada_horario === "PONTA") {
                if (!inicioPonta) inicioPonta = dataAtual;
            } else {
                if (inicioPonta) {
                    adicionarRange(inicioPonta, dataAtual, "#cd0137", "Ponta", 0.15);
                    inicioPonta = null;
                }
            }

            if (item.demanda_contratada_horario === "RESERVADO") {
                if (!inicioReservado) inicioReservado = dataAtual;
            } else {
                if (inicioReservado) {
                    adicionarRange(inicioReservado, dataAtual, "#5500f4", "Reservado", 0.15);
                    inicioReservado = null;
                }
            }

            // 🔚 Fecha blocos no último item
            if (index === lista.length - 1) {
                if (inicioPonta) {
                    adicionarRange(inicioPonta, dataAtual, "#cd0137", "Ponta", 0.15);
                }
                if (inicioReservado) {
                    adicionarRange(inicioReservado, dataAtual, "#5500f4", "Reservado", 0.15);
                }
            }
        });
        seriesAtivas.push(seriesDem);
    }

    // Adicione a série ao array de séries ativas

    // Adiciona cursor
    chart.cursor = new am4charts.XYCursor();
    chart.cursor.xAxis = dateAxis;
    chart.cursor.snapToSeries = seriesAtivas;

    if (modoSimulado) {
        // Série para "Q (kVAr) Simulado"
        const seriesQSimulado = chart.series.push(new am4charts.LineSeries());
        seriesQSimulado.dataFields.valueY = "q_simulado"; // Campo para "Q (kVAr)"
        seriesQSimulado.dataFields.dateX = "data_hora";
        seriesQSimulado.name = "Q (kVAr) Simulado";
        seriesQSimulado.tooltipText = `Q (kVAr) Simulado às {dateX.formatDate("dd/MM/yyyy HH:mm")}h: [bold]{valueY.formatNumber("###,###,###,###.00")} kVAr[/]`;
        seriesQSimulado.strokeWidth = 2;
        seriesQSimulado.tensionX = 1;
        seriesQSimulado.stroke = am4core.color("#ff0077");
        seriesQSimulado.fill = am4core.color("#ff0077");
        seriesQSimulado.fillOpacity = 0.2;

        // Adiciona cursor
        chart.cursor.snapToSeries.push(seriesQSimulado);
    }

    // Scrollbar
    chart.scrollbarX = new am4charts.XYChartScrollbar();
    for (const sa of seriesAtivas) {
        chart.scrollbarX.series.push(sa);
    }
    chart.scrollbarX.unselectedOverlay.fill = am4core.color("#fff");
    chart.scrollbarX.unselectedOverlay.fillOpacity = 0.7;
    chart.scrollbarX.unselectedOverlay.stroke = am4core.color("#fff");

    chart.scrollbarX.background.fill = am4core.color("#fff");
    chart.scrollbarX.thumb.background.fill = am4core.color("#2190ff"); //cor do trecho selecionado
    chart.scrollbarX.thumb.background.fillOpacity = 0.3; //opacidade da cor do trecho selecionado
    chart.scrollbarX.stroke = am4core.color("#003040"); // cor do texto dentro do trecho seleionado
    chart.scrollbarX.strokeWidth = 0;

    //Cor da scrollbar ao passar o mouse
    chart.scrollbarX.startGrip.background.states.getKey("hover").properties.fill = am4core.color("#2190ff");
    chart.scrollbarX.startGrip.background.states.getKey("hover").properties.fillOpacity = 0.3;

    chart.scrollbarX.endGrip.background.states.getKey("hover").properties.fill = am4core.color("#2190ff");
    chart.scrollbarX.endGrip.background.states.getKey("hover").properties.fillOpacity = 0.3;

    chart.scrollbarX.thumb.background.states.getKey("hover").properties.fill = am4core.color("#2190ff");
    chart.scrollbarX.thumb.background.states.getKey("hover").properties.fillOpacity = 0.3;

    //Adiciona legenda
    chart.legend = new am4charts.Legend();
    chart.legend.labels.template.fill = am4core.color("#000");
    chart.legend.valueLabels.template.fill = am4core.color("#000");
    chart.legend.contentAlign = "center"; // centraliza tudo
    if (isMobile) {
        chart.legend.position = "center";

        // Remove espaçamento exagerado

        // Força largura fixa do item da legenda
        chart.legend.itemContainers.template.width = 50; // ajuste fino (80–110)
        chart.legend.itemContainers.template.maxWidth = 80;

        // Permite quebrar linha
        chart.legend.labels.template.wrap = true;
        chart.legend.labels.template.truncate = false;
        chart.legend.labels.template.maxWidth = 70;

        chart.legend.labels.template.fontSize = 10;
    }

    // Configura a cor do tooltip do eixo X
    const dateAxisTooltip = dateAxis.tooltip;
    dateAxisTooltip.background.fill = am4core.color("#0070cc");
    dateAxisTooltip.stroke = am4core.color("#fff");
    dateAxisTooltip.background.strokeWidth = 0;
    dateAxisTooltip.background.cornerRadius = 3;
    dateAxisTooltip.background.pointerLength = 0;
    dateAxisTooltip.dy = 5;

    // Configura a cor do tooltip do eixo Y compartilhado
    const valueAxisTooltip = valueAxis.tooltip;
    valueAxisTooltip.background.fill = am4core.color("#0070cc");
    valueAxisTooltip.stroke = am4core.color("#fff");
    valueAxisTooltip.background.strokeWidth = 0;
    valueAxisTooltip.background.cornerRadius = 3;
    valueAxisTooltip.background.pointerLength = 0;
    valueAxisTooltip.dy = 5;
    // valueAxis.renderer.line.strokeOpacity = 1;
    // valueAxis.renderer.line.strokeWidth = 1;

    // Configurações adicionais para garantir boa visualização
    valueAxis.tooltip.disabled = false; // Garante que o tooltip seja exibido
    dateAxis.tooltip.disabled = false; // Garante que o tooltip seja exibido

    // Configura dados
    chart.data = lista.map((leitura) => {
        const { p, q, demanda_contratada_quantidade, demanda_contratada_horario, q_simulado, data_hora } = leitura;
        return { p, q, demanda_contratada_quantidade, demanda_contratada_horario, q_simulado, data_hora: new Date(data_hora) };
    });

    // Customiza botões da scrollbar
    customizeChartGrip(chart.scrollbarX.startGrip);
    customizeChartGrip(chart.scrollbarX.endGrip);

    return setGrafico(chart);
}
